import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, IconButton, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Arbitrator, AttributeModiferKeys } from './Arbitrator';
import { camelCase_to_Sentence, toTitleCase } from '../../../../../helpers/format';
import { AutosizedTextField } from '../../../../common/AutosizedTextField';
import { ActionIcons } from '../../../../../Iconography';
/**
 * CRA: 2025 08 — TODO, this is a work-in-progress
 */
export const ArrayAttribute = (props) => {
    const { name, attribute, rangeLimits, disable, isRoot } = props;
    const { attributeType, range, start, end, ...others } = rangeLimits;
    const INITIAL = `${start ?? 0}`;
    const [checked, setChecked] = useState(false);
    const [value, setValue] = useState(INITIAL);
    const disabled = isRoot ? !checked : disable;
    useEffect(() => {
        if (disabled)
            setChecked(false);
        if (value !== INITIAL && disabled)
            setValue(INITIAL);
    }, [disabled, value]);
    const more = [];
    const payload = {};
    let valid = !disabled;
    for (const [key, other] of Object.entries(others)) {
        if (!AttributeModiferKeys.includes(key)) {
            const { elements, payload: p, valid: v, } = Arbitrator({
                name: key,
                attribute,
                rangeLimits: other,
                disable: isRoot ? !checked : disable,
                isRoot: false,
            });
            more.push(elements);
            payload[name] ??= {};
            if (p[key] !== undefined)
                payload[name][key] = p[key];
            valid = valid && v;
        }
    }
    const readableName = toTitleCase(camelCase_to_Sentence(name));
    const { min, max } = range;
    const placeholder = start + ' - ' + end;
    const float = Number.parseFloat(value);
    const int = Number.parseInt(value);
    const number = float === int ? int : NaN;
    const canAdd = valid && !isNaN(number) && number < (end ?? Number.POSITIVE_INFINITY);
    const canRemove = valid && !isNaN(number) && (start ?? 0) < number;
    valid = valid && !isNaN(number) && (start ?? 0) <= number && number <= (end ?? Number.POSITIVE_INFINITY);
    const INITIAL_ARRAY = new Array(start ?? 0).fill(min ?? 0);
    const [array, setArray] = useState(INITIAL_ARRAY);
    if (!disabled)
        payload[name] = array;
    useEffect(() => {
        if (valid) {
            if (array.length === number)
                return;
            if (array.length < number)
                return setArray((a) => a.concat(new Array(number - array.length).fill(min ?? 0)));
            if (number < array.length)
                return setArray((a) => a.slice(0, number));
        }
        if (array.length !== INITIAL_ARRAY.length && disabled)
            return setArray(INITIAL_ARRAY);
    }, [number]);
    const present = isRoot && _jsx(Checkbox, { checked: checked, onChange: (e) => setChecked(e.target.checked), disabled: disable });
    const control = (_jsxs(Stack, { direction: "row", gap: 1, children: [_jsx(IconButton, { disabled: !canRemove, onClick: () => setValue((number - 1).toString()), children: _jsx(ActionIcons.Remove, {}) }), _jsx(AutosizedTextField, { value: value, onChange: (e) => setValue(e.target.value), placeholder: placeholder, autoComplete: "number", disabled: disabled, error: !valid }), _jsx(IconButton, { disabled: !canAdd, onClick: () => setValue((number + 1).toString()), children: _jsx(ActionIcons.Create, {}) })] }));
    const indicies = valid ? (array.map((v) => {
        const placeholder = `${min ?? 0} - ${max ?? ''}`;
        return _jsx(AutosizedTextField, { value: v, placeholder: placeholder });
    })) : (_jsx(_Fragment, {}));
    const elements = more.length ? (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [present, _jsx(Typography, { children: readableName }), _jsxs(Stack, { gap: 1, children: [control, indicies] }), _jsxs(Stack, { gap: 1, children: [...more] })] })) : (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [present, !isRoot && _jsx(Typography, { color: disabled ? 'textDisabled' : undefined, children: readableName }), _jsxs(Stack, { gap: 1, children: [control, indicies] })] }));
    return { elements, payload, valid };
};
